
import style from "css/workspace.module.css";
import { Route, Routes } from "react-router-dom";
import Main from "./detail/main";
import Symposium from "./detail/symposium";
import Telecollaboration from "./detail/telecollaboration";
import Telehealth from "./detail/telehealth";
import TeleRounding from "./detail/teleRounding";
function TelehealthMain() {
  return (
    <div className={style.fontsize}>
      <Routes>
        <Route path="telehealth" element={<Telehealth />} />
        <Route path="telerounding" element={<TeleRounding />} />
        <Route path="telecollaboration" element={<Telecollaboration />} />
        <Route path="symposium" element={<Symposium />} />
        <Route path="*" element={<Main />} />
      </Routes>
    </div>
  );
}

export default TelehealthMain;
